<template>
  <div id="app">
    <!-- <datav /> -->
    <router-view/>
  </div>
</template>

<script>
// import datav from './components/datav/index.vue'

export default {
  name: 'app',
  components: {
    // datav
  },
  data () {
    return {}
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
#home-container{
  height: 100%;
  overflow: hidden;
  width: 100%;
  background-color: #1C1433;
}
#top-div-container{
  margin-left: 3.33rem;
  margin-top: 1.67rem;
  margin-right: 3.33rem;
  height: 33.33rem;
  display: flex;
}
#bottom-div-container{
  margin-left: 3.33rem;
  margin-top: 1.67rem;
  margin-right: 3.33rem;
  height: 43.33rem;
  display: flex;
}
</style>
